import { render, staticRenderFns } from "./ChangePhoto.vue?vue&type=template&id=347f1165&scoped=true"
import script from "./ChangePhoto.vue?vue&type=script&lang=js"
export * from "./ChangePhoto.vue?vue&type=script&lang=js"
import style0 from "./ChangePhoto.vue?vue&type=style&index=0&id=347f1165&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347f1165",
  null
  
)

export default component.exports